import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, CarIcon, SmartphoneIcon, ShieldCheckIcon, CalendarIcon, MapPinIcon } from 'lucide-react';
export function ServiceConvenience() {
  const features = [{
    icon: <CalendarIcon className="h-8 w-8 text-brand-accent" data-id="element-118" data-mp="2fvff7eexryd8" />,
    text: 'Book online in minutes — no phone tag'
  }, {
    icon: <ClockIcon className="h-8 w-8 text-brand-accent" data-id="element-119" data-mp="2av1d0d00nin4" />,
    text: 'After-hours drop-off and pickup'
  }, {
    icon: <CarIcon className="h-8 w-8 text-brand-accent" data-id="element-120" data-mp="1j681utoh0vke" />,
    text: 'Loaner vehicles for longer repairs'
  }, {
    icon: <MapPinIcon className="h-8 w-8 text-brand-accent" data-id="element-121" data-mp="1wxv0h05vyg6c" />,
    text: 'Free rideshare when you need it'
  }, {
    icon: <SmartphoneIcon className="h-8 w-8 text-brand-accent" data-id="element-122" data-mp="1s51wiei8rbvb" />,
    text: 'Digital estimates sent to your phone before work begins'
  }, {
    icon: <ShieldCheckIcon className="h-8 w-8 text-brand-accent" data-id="element-123" data-mp="zih55e1rmzrr" />,
    text: '2-year / 24,000-mile warranty on qualifying repairs'
  }];
  return <section className="bg-brand-dark px-4 py-20 text-white" data-id="element-124" data-mp="3uckie2tavedm">
      <div className="mx-auto max-w-6xl" data-id="element-125" data-mp="37c2rz2ufnut">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center" data-id="element-126" data-mp="360x1tpu8612">
          <span className="mb-4 block text-sm font-bold uppercase tracking-widest text-brand-accent" data-id="element-127" data-mp="3gf5oolw0kkfu">
            A SHOP THAT WORKS AROUND YOUR LIFE
          </span>
          <h2 className="mb-6 font-heading text-3xl font-extrabold uppercase tracking-wide md:text-4xl lg:text-5xl" data-id="element-128" data-mp="3pftzz8u0w6p1">
            STAYING ON TOP OF MAINTENANCE SHOULDN&apos;T BE HARD.
          </h2>
          <p className="mx-auto max-w-3xl text-lg text-gray-300 md:text-xl" data-id="element-129" data-mp="14ol4v57ny9uk">
            We&apos;ve built the shop around the reality that people are busy.
            The harder it is to get in, the easier it is to push maintenance
            off. So we&apos;ve tried to remove every reason not to.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3" data-id="element-130" data-mp="3apvxt1co3u8x">
          {features.map((feature, index) => <motion.div key={feature.text} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center rounded-2xl border border-gray-700 bg-gray-800/50 p-8 text-center transition-colors hover:bg-gray-800" data-id="element-131" data-mp="2i1qd2elm6593" data-mpi={index}>
              <div className="mb-6 rounded-full border border-gray-700 bg-gray-900 p-4" data-id="element-132" data-mp="9umvmiw0xv9m">
                {feature.icon}
              </div>
              <p className="text-lg font-medium text-gray-200" data-id="element-133" data-mp="elwhd8egceg8">
                {feature.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}